module.exports = __webpack_public_path__ + "img/sixpackcarrier75.9cb3dbea.jpg";